<script setup>
import { useHead } from 'unhead';
import { useI18n } from 'vue-i18n';

import Footer from '../components/Footer.vue';

const { t } = useI18n();

useHead({
    title: `${t('notFound.title')} — ${t('app.name')}`,
    meta: [
        {
            name: "og:site_name",
            content: t('app.name')
        },
        {
            name: "og:type",
            content: "website"
        },
        {
            name: "twitter:creator",
            content: "@KeyFrameStaff"
        },
        {
            name: "twitter:site",
            content: "@KeyFrameStaff"
        },
        {
            name: "og:title",
            content: `${t('notFound.title')} — ${t('app.name')}`
        },
        {
            name: "description",
            content: t('notFound.message')
        },
        {
            name: "og:description",
            content: t('notFound.message')
        }
    ]
});
</script>

<template>
    <main class="px-10 py-40 text-center">
        <h1 class="text-9xl text-keyframe font-bold">404</h1>
        <h2 class="text-3xl text-keyframe font-bold">{{ $t('notFound.heading') }}</h2>

        <p class="mt-6">{{ $t('notFound.message') }}</p>

        <RouterLink to="/" class="btn btn-keyframe block mx-auto w-max mt-6">
            <font-awesome-icon icon="fa-solid fa-arrow-left" />
            {{ $t('common.goBack') }}
        </RouterLink>
    </main>

    <Footer />
</template>